export const MOBLIE_VALIDATION = {
  required: { value: true, message: 'Mobile number is required.' },
  pattern: {
    value: /^(0)?[1,2,3,7,8][0-9]{9}$/,
    message: 'Please enter a valid mobile number',
  },
};
